import styled from 'styled-components';

const Wrapper = styled.div`
  display: flex;
  align-items: center;

  ${({ showSeparator }) => showSeparator && `
    &::after {
      width: 1px;
      content: ' ';
      background: transparent;
      border-right: 1px #B5BEC6;
      border-right-style: dashed;
      height: 14px;
      margin: 0px 8px 0px 18px;
    }
  `}
`;
Wrapper.displayName = 'Wrapper';

export default Wrapper;
